/** Global styles - migrated from styled-components createGlobalStyle + twin.macro BaseStyles */
const GlobalStylesComponent = () => {
  return (
    <style jsx global>{`
      .alice-carousel__stage-item {
        min-width: 77px !important;
        margin-right: 8px;
      }
      /* Equal-height cards in the job-position card carousels (proposed jobs + similar
         positions). react-alice-carousel lays items out inline-block / vertical-align: top, so a
         card with a 2-line title grew taller and dropped its CTA below the neighbours. Making the
         stage a flex row lets align-items: stretch size every item to the tallest; flex-shrink: 0
         keeps each card at its autoWidth. Scoped via .jp-card-carousel so other carousels are
         untouched. */
      .jp-card-carousel .alice-carousel__stage {
        display: flex;
      }
      .jp-card-carousel .alice-carousel__stage-item {
        flex-shrink: 0;
        height: auto;
      }
      .dialog-open {
        overflow: visible !important;
      }
      /* Save-search drawer open on a phone: the Intercom launcher would cover its footer button.
         The class is set by useHideIntercomLauncherOnMobile. */
      body.save-search-modal-open [class^='intercom-'],
      body.save-search-modal-open [id^='intercom-'] {
        display: none !important;
      }
      /* Full-screen Serena chat (/candidature/[id]/intervista): nothing may float over the
         composer. The chat adds this class to <body> while mounted; it hides the Intercom
         launcher and, in dev only, the Jotai and TanStack Query devtools triggers (neither is
         rendered in production). */
      body.assessment-chat-fullscreen [class^='intercom-'],
      body.assessment-chat-fullscreen [id^='intercom-'],
      body.assessment-chat-fullscreen .jotai-devtools-trigger-button,
      body.assessment-chat-fullscreen .tsqd-parent-container,
      body.assessment-chat-fullscreen [aria-label='Open Tanstack query devtools'] {
        display: none !important;
      }
      /* Full-screen chat: the document itself takes the page colour (neutral-10), because
         iOS Safari paints the area behind its toolbars with the document background, and
         the chat shell is a fixed box that does not reach there. */
      html:has(body.assessment-chat-fullscreen),
      body.assessment-chat-fullscreen {
        background-color: #fafafa;
      }
      .react-date-picker__calendar {
        inset: auto auto -120px 0px !important;
      }
      .maplibregl-map {
        font: unset !important;
      }
    `}</style>
  );
};

export default GlobalStylesComponent;
